import initialState from '@/store/modules/geo/state.js'

export default {
  RESET_GEO_MODULE(state) {
    Object.keys(initialState).forEach((key) => {
      state[key] = initialState[key]
    })
  },
}
